import classNames from 'classnames';
import Scrollbar  from '../base/Scrollbar';

const Timeline = ({
  children,
  variant,
  className
}) => {
  return (
    <Scrollbar style={{ minHeight: 1800 }}>
    <div
      className={classNames(className, {
        'timeline-basic': variant === 'basic',
        'timeline-vertical': variant === 'vertical'
      })}
    >
      {children}
    </div>
      </Scrollbar>
  );
};

export const TimelineItem = ({
  children,
  className
}) => {
  return (
    <div className={classNames(className, 'timeline-item')}>{children}</div>
  );
};

export const TimelineOppositeContent = ({
  children,
  className
}) => {
  return (
    <div className={classNames(className, 'order-1 order-md-0 me-md-4')}>
      {children}
    </div>
  );
};

export const TimelineContent = ({
  children,
  className
}) => {
  return (
    <div className={classNames(className, 'ps-6 ps-md-3')}>{children}</div>
  );
};

export const TimelineSeparator = ({
  children,
  className
}) => {
  return (
    <div className={classNames(className, 'timeline-separator me-3 me-md-0')}>
      {children}
    </div>
  );
};

export const TimelineDot = ({
  children,
  className
}) => {
  return (
    <div className={classNames(className, 'icon-item icon-item-sm')}>
      {children}
    </div>
  );
};

export const TimelineBar = ({ className, ...rest }) => {
  return (
    <span
      className={classNames(className, 'timeline-bar border-end')}
      {...rest}
    />
  );
};

Timeline.Item = TimelineItem;
Timeline.OppositeContent = TimelineOppositeContent;
Timeline.Content = TimelineContent;
Timeline.Separator = TimelineSeparator;
Timeline.Bar = TimelineBar;
Timeline.Dot = TimelineDot;

export default Timeline;
